<template>
  <section class="container">
    <div class="btn-group"/>

    <el-form label-width="100px">
      <el-form-item label="标题">
        <el-input v-model="editObject.brand_title"/>
      </el-form-item>
      <el-form-item label="英文标题">
        <el-input v-model="editObject.brand_english_title"/>
      </el-form-item>
      <el-form-item label="跳转链接">
        <el-input v-model="editObject.brand_url"/>
      </el-form-item>
      <el-form-item label="所属风格">
        <!-- <el-input v-model="editObject.style_title"/> -->
        <el-select
          v-model="editObject.style_uuid"
          placeholder="请选择">
          <el-option
            v-for="item in styleList"
            :key="item.uuid"
            :label="item.style_title"
            :value="item.uuid"/>
        </el-select>
      </el-form-item>
      <el-form-item label="附件">
        <el-upload
          class="upload-demo"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadFileSuccess"
          :show-file-list="false"
          list-type="picture">
          <el-button
            size="small"
            type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="图片">
        <el-upload
          class="avatar-uploader"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadSuccess"
          :show-file-list="false">
          <img
            v-if="editObject.brand_img"
            :src="qiniuDomain + editObject.brand_img"
            class="avatar">
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"/>
        </el-upload>
      </el-form-item>
      <el-form-item label="banner">
        <el-upload
          class="upload-demo"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadBannerSuccess"
          :show-file-list="false"
          list-type="picture">
          <el-button
            size="small"
            type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <div
          v-if="editObject.brand_banner"
          class="banner-box">
          <img
            :src="qiniuDomain + editObject.brand_banner"
            class="banner-img" >
        </div>
      </el-form-item>
      <el-form-item label="副文本">
        <!-- <el-input v-model="editObject.brand_content"/> -->
        <quill-editor
          v-model="editObject.brand_content"/>
      </el-form-item>
      <el-form-item label="英文副文本">
        <!-- <el-input v-model="editObject.brand_content"/> -->
        <quill-editor
          v-model="editObject.brand_english_content"/>
      </el-form-item>
      <el-form-item>
        <el-button @click="onSave">保存</el-button>
      </el-form-item>
    </el-form>

  </section>
</template>

<script>
import QuillEditor from '@/components/quill-editor';
import Mixins from '@/mixins/operations'
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  styleList, addBrand,
} from '@/api/style'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      styleList: [],
      editObject: { //  根据接口来的命名，不是很喜欢---
        brand_title: '',
        brand_english_title: '',
        brand_img: '',
        style_uuid: '',
        brand_url: '',
        brand_content: '',
        brand_english_content: '',
        brand_file: '',
        brand_banner: '',
      },
    };
  },
  mixins: [Mixins],
  components: {
    QuillEditor,
  },

  created() {
    this.network().getQiniuInfo()
    this.network().styleList()
  },
  methods: {
    uploadSuccess(res) {
      this.editObject.brand_img = res.hash
    },
    uploadBannerSuccess(res) {
      this.editObject.brand_banner = res.hash
    },
    uploadFileSuccess(res) {
      this.editObject.brand_file = res.hash
      this.$message({
        message: '上传附件成功',
        type: 'success',
      })
    },
    onSave() {
      if (!this.event().inputVerify()) return
      this.network().addBrand()
    },
    event() {
      return {
        inputVerify: () => {
          if (!this.editObject.brand_title) {
            this.$message('请填写标题')
            return false
          }
          if (!this.editObject.brand_english_title) {
            this.$message('请填写英文标题')
            return false
          }

          // eslint-disable-next-line
          const httpReg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
          if (this.editObject.brand_url && !httpReg.test(this.editObject.brand_url)) {
            this.$message('跳转链接格式不正确')
            return false
          }
          if (!this.editObject.style_uuid) {
            this.$message('请选择所属风格')
            return false
          }
          if (!this.editObject.brand_img) {
            this.$message('请上传图片')
            return false
          }
          if (this.editObject.brand_banner.length < 1) {
            this.$message('请上传banner')
            return false
          }
          if (!this.editObject.brand_content) {
            this.$message('请填写副文本')
            return false
          }
          if (!this.editObject.brand_english_content) {
            this.$message('请填写英文副文本')
            return false
          }
          return true
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        addBrand: async () => {
          const { status } = await addBrand(this.editObject)
          if (status === 200) {
            this.$message({
              message: '添加成功',
              type: 'success',
            })
          }
        },
        styleList: async () => {
          const { status, data } = await styleList({
            page_index: 1,
            page_count: 999,
          })
          if (status === 200) {
            this.styleList = data.char
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
   .banner-box {
    position: relative;
    margin-right: 20px;
    display: inline-block;
    width: 200px;
    height: 100px;
  }
  .banner-box .icon {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
  .el-form {
    width: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/style/brand-add.vue